import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import FormAdd from "../../components/tickets/FormAddTicket";
import ItemProductList from "../../components/tickets/ItemProductList";
import TicketProductList from "../../components/tickets/TicketProductList";
import ClientContract from "../../components/tickets/ClientContract";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../../features/authSlice";

const AddTicket = () => {
  const [show, setShow] = useState('product');
  const [cart, setCart] = useState([]);
  const [clientid, setClentId] = useState(null);
  const [contract, setContract] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError } = useSelector((state) => state.auth);
  
  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
  }, [isError, navigate]);

  const handleClick = (item) => {
    if (cart.indexOf(item) !== -1) return;
    setCart([...cart, item]);
    // console.log(show);
    setShow('ticket');
  };

  const handleAdd = (item, clientid, endgaransi) => {
    const start = new Date();
    const end = new Date(endgaransi);
    const timeDifference = end.getTime() - start.getTime(); // Difference in milliseconds
    const millisecondsPerDay = 1000 * 60 * 60 * 24; // Milliseconds in a day
    const daysDifference = Math.floor(timeDifference / millisecondsPerDay); // Use Math.floor for whole days
    if(daysDifference < 0){
      alert('Contract has Expired');
    }else{
      if (cart.indexOf(item) !== -1) return;
      if (cart.length > 0){
        alert("One ticket one product, please create a new ticket for your other product issues");
        return
      }
      setCart([...cart, item]);
      setClentId(clientid);
      //console.log(cart.length);
      setShow('ticket');
    }   
  };

  const handleCheck = (item) => {
    setContract(item);
    //console.log(contract);
    setShow('contract');
  };

  const handleChange = (item, d) => {
    const ind = cart.indexOf(item);
    const arr = cart;
    arr[ind].amount += d;

    if (arr[ind].amount === 0) arr[ind].amount = 1;
    setCart([...arr]);
  };
  return (
    <Layout>
      <FormAdd setShow={setShow} size={cart.length} />
      
      {show === 'product' ? (
        <ItemProductList handleClick={handleClick} handleCheck={handleCheck} />
      ) : show === 'ticket' ? (
        <TicketProductList cart={cart} setCart={setCart} clientid={clientid} handleChange={handleChange} />
      ) : (
        <ClientContract contract={contract} setContract={setContract} handleAdd={handleAdd}/>
      )}
    </Layout>
  );
};

export default AddTicket;
